<template>
  <popup-layout :title="'카테고리 ' + typeText" width="460" :is-show="isShow">
    <template v-slot:content>
      <field-input title="카테고리명">
        <v-text-field
            v-model="categoryData.categoryNm"
            placeholder="입력"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
      <field-input title="노출여부" v-if="type !== 'new'">
        <v-select
            v-model="categoryData.useYn"
            :items="useYnList"
            item-text="text"
            item-value="value"
            placeholder="선택"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
      <field-input title="이용권한">
        <v-select
            v-model="categoryData.useRole"
            :items="useRoleList"
            item-text="text"
            item-value="value"
            placeholder="선택"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="isSave">저장</v-btn>
        <v-btn class="button delete" outlined @click="closePopup">취소</v-btn>
      </div>
    </template>
  </popup-layout>
</template>

<script>
import _ from "lodash";
import PopupLayout from "@/common/layout/PopupLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import constant from "@/util/constant";
import {axiosInstance} from "@/util/AxiosModule";

export default {
  name: "CategoryPopup",
  components: {FieldInput, PopupLayout},
  props: ["isShow", "type", "editItemProps"],

  data() {
    return {
      categoryData: {},
      useYnList: [
        { text: "노출", value: "Y" },
        { text: "미노출", value: "N" }
      ],
      useRoleList: constant.CATEGORY_ROLE_LIST
    }
  },
  computed: {
    typeText(){
      return this.type === 'new' ? '추가' : '수정';
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        if (!_.isEmpty(this.editItemProps)) {
          this.categoryData = _.cloneDeep(this.editItemProps);
        } else {
          this.categoryData = {};
        }
      }
    }
  },
  methods: {
    isSave() {
      if (
          _.isEmpty(this.categoryData.categoryNm) ||
          _.isEmpty(this.categoryData.useRole)
      ) {
        this.showAlert({message: "입력하신 내용을 다시 한번 확인해주세요"});
        return false;
      }

      this.showConfirm({
        message: `${this.typeText}한 내용을 저장하시겠습니까?`,
        successCallback: () => {
          if (this.type === "new") {
            this.save();
          } else {
            this.modify();
          }
        },
        failCallback: () => {
          return false;
        }
      })
    },
    // 카테고리 추가
    async save() {
      const params = {
        categoryNm: this.categoryData.categoryNm,
        useRole: this.categoryData.useRole
      };
      try {
        await axiosInstance.put("/admin/training/category", {}, { params })
            .then(() => {
              this.showAlert({
                message: "카테고리가 추가되었습니다",
                successCallback: () => {
                  this.$emit("refresh");
                  this.closePopup();
                }
              })
            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    // 카테고리 수정
    async modify() {
      const category = _.cloneDeep(this.categoryData);
      try {
        await axiosInstance.patch("/admin/training/category", category)
            .then(() => {
              this.showAlert({
                message: "수정이 완료되었습니다",
                successCallback: () => {
                  this.$emit("refresh");
                  this.closePopup();
                }
              })
            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    closePopup() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
}
</style>